import ValueLoader from '@components/_shared/ValueLoader';
import { memo, ReactElement } from 'react';
import { CellProps } from './types';

const Cell: React.FC<CellProps> = ({ dataPoint }): ReactElement => {
  return <ValueLoader dataPoint={dataPoint} />;
};

Cell.displayName = 'Cell';

export default memo(Cell, (prevProps, nextProps) => {
  return (
    prevProps.dataPoint?.value === nextProps.dataPoint?.value &&
    prevProps.dataPoint?.ts === nextProps.dataPoint?.ts &&
    prevProps.dataPoint?.pointAlias === nextProps.dataPoint?.pointAlias
  );
});
